export default "__VITE_ASSET__sVhcVt96__"